/**
 * Strips all spaces and characters (except +) from a phone number
 *
 * @param {String} phoneNumber
 * @returns {String} containing the cleaned phone number (e.g., +12021234567)
 */
export function cleanPhoneNumber(phoneNumber) {
    return phoneNumber.replace(/[\s()-]/g, "");
}
